module.exports = __webpack_public_path__ + "media/images/icons/copy-icon-8c677f483cafde0ccf49a98113fccf9a.svg";